import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {__} from "~/ts/library/Translate";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";

export default async function toggleMessagePin(username: string, messageId: number, pinned: boolean) {
    if (OperatorAccountStore.isAuthorized.value) {
        try {
            await ElConfirm(!pinned ? __("Вы уверены, что хотите открепить это сообщение?") : __("Вы уверены, что хотите закрепить это сообщение?"));
            let p: OperatorApplicationApi.OperatorMessageTogglePinOpenApiModel = {
                messageId,
                pinned,
                username
            };
            await (new OperatorApiRequest({
                url: "/message/togglePin",
                p
            })).send();
        } catch (e) {
        }
    }
}